/* eslint-disable import/prefer-default-export */

import { LocaleTypes } from '@i18n';
import { companyName } from '@config/globalDomain';

export const getSeoTextByLocale = (locale: LocaleTypes): React.ReactElement => {
    switch (locale) {
        case LocaleTypes.en:
            return (
                <>
                    <p className="text-blueGray-600 text-p1">
                        Which affiliate programs are considered high-paying? On the one hand, all
                        webmasters want to get the highest percentage of agent commission from each
                        deal. However, a low approval rate can significantly reduce earnings, so the
                        webmaster has to look for affiliate programs with a high agent commission
                        and high approval rate of deals at the same time.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        In addition, the assortment of an online store should be wide enough that
                        the visitor can accurately find the product of interest to him. And this is
                        another important requirement for affiliate programs.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Finally, experienced webmasters also pay attention to the duration of the
                        hold and the cookies lifetime. The first parameter shows how many days
                        should pass from the moment the purchase is made until the webmaster
                        receives the payment. The second parameter shows how long after the first
                        visit the buyer must make a purchase in order for the webmaster to receive
                        the agency commission.
                    </p>
                    <div className="my-5 font-medium text-blueGray-600 text-p1">
                        Thus, it is obvious that the highest paying affiliate programs should have:
                        <ul className="list-disc ml-[20px]">
                            <li>
                                <span>a high commission percentage;</span>
                            </li>
                            <li>
                                <span>a high percentage of deals approval;</span>
                            </li>
                            <li>
                                <span>a wide range and convenient service for customers;</span>
                            </li>
                            <li>
                                <span>a short hold period;</span>
                            </li>
                            <li>
                                <span>a long lifespan of cookies.</span>
                            </li>
                        </ul>
                    </div>
                    <p className="text-blueGray-600 text-p1">
                        If you managed to find just such an affiliate program for your traffic
                        source, you will definitely be able to earn good money! We wish you good
                        luck!
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Choose an affiliate program from the arsenal of CPA-network {companyName}{' '}
                        and earn money on your subscribers&apos; purchases!
                    </p>
                </>
            );
        case LocaleTypes.ru:
        default:
            return (
                <>
                    <p className="text-blueGray-600 text-p1">
                        Рассмотрим работу высокооплачиваемых партнерских программ на примере
                        eCommerce Partners Network. Это одна из первых партнёрок в России, которая
                        уверенно входит в топ-10 партнерских программ СНГ. Мы заключили договора
                        более чем с 220 интернет-магазинами России и мира.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Русские партнерки сети {companyName} работают с блогерами, владельцами
                        сайтов, YouTube- и телеграмм-каналов. После регистрации в партнерке владелец
                        трафика получает возможность выбрать оффер (магазин) и создать партнерскую
                        ссылку на любой товар из ассортимента, либо любой лендинг, а также право
                        свободно размещать его на своем ресурсе. Вебмастер видит статистику
                        переходов по ссылке, количество совершенных покупок, их стоимость и размер
                        своего агентского вознаграждения. В результате магазин получает продажи, а
                        блоггер - заработок. За надежностью и честностью сделки следит {companyName}
                        .
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        А в чем выгода покупателя, для чего он принимает участие в этом процессе?
                        Все просто. Каждый человек перед тем, как совершить покупку, будь то
                        ноутбук, посудомоечная машина, мобильный телефон, одежда, обувь игрушки для
                        детей начинает искать информацию в интернете с целью подобрать действительно
                        хороший и подходящий продукт. Для этого люди просматривают сайты, блоги,
                        смотрят обзоры на YouTube и в телеграм-каналах. После того как информация о
                        нужном изделии с подходящими параметрами найдена, нет необходимости искать
                        магазин и полюбившийся товар. Тут же в статье на сайте или блоге практически
                        всегда можно увидеть кнопку с надписью «купить» или «купить со скидкой», или
                        просто ссылку для перехода.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Таким образом, в партнерской программе в выигрыше все стороны:
                        интернет-магазин продает единицу товара. На продажу он не тратил деньги на
                        рекламу: ни на создание, ни на продвижение.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Блогер или вебмастер получает вознаграждение (процент с продажи товара). Ему
                        не нужен свой продукт, более того он может выбрать и несколько товаров даже
                        из разных партнерских программ.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Покупатель получает товар с нужными параметрами у надежного продавца, иногда
                        и со скидкой.
                    </p>
                    <h2 className="my-5 font-medium text-h2 text-blueGray-800">
                        Как строится рейтинг партнерских программ?
                    </h2>
                    <p className="text-blueGray-600 text-p1">
                        Не секрет, что в каталогах и агрегаторах партнерских программ можно
                        встретить определенное число “серых” партнерок, которые могут не выплатить
                        заработок не только новичкам, но и опытным вебмастерам и арбитражникам. Для
                        того, чтобы таких случаев было меньше создаются рейтинги партнерских
                        программ. Топ партнерских программ строится на живом голосовании вебмастеров
                        и дополняется их отзывами.
                    </p>
                    <div className="my-5 font-medium text-blueGray-600 text-p1">
                        Критерии оценивания таковы:
                        <ul className="list-disc ml-[20px]">
                            <li>
                                <span>Вознаграждение (комиссия)</span> –{' '}
                                <span className="font-normal">
                                    размер комиссии и срок выплат (время холда);
                                </span>
                            </li>
                            <li>
                                <span>Ассортимент</span> –{' '}
                                <span className="font-normal">
                                    как много товаров партнер может предложить покупателю;
                                </span>
                            </li>
                            <li>
                                <span>Функционал</span> –{' '}
                                <span className="font-normal">
                                    услуги и сервисы, которые продавец готов предложить клиенту;
                                </span>
                            </li>
                            <li>
                                <span>Поддержка</span> –{' '}
                                <span className="font-normal">
                                    быстрота ответа службы поддержки и профессиональность работы,
                                    качество оказываемой помощи.
                                </span>
                            </li>
                        </ul>
                    </div>
                    <p className="text-blueGray-600 text-p1">
                        Так или иначе, каждый опытный вебмастер создает для себя свой собственный
                        обзор партнерских программ, основываясь на важных для него и его аудитории
                        критериях.
                    </p>
                    <h2 className="my-5 font-medium text-h2 text-blueGray-800">
                        О партнерских программах интернет-магазинов
                    </h2>
                    <p className="text-blueGray-600 text-p1">
                        В последние несколько лет крупные бренды стали уделять больше внимания
                        продажам в онлайн-пространстве и обратили свое внимание на партнерские
                        программы. Немалую роль в этом сыграли “ковидные” ограничения.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        И для продвижения своей продукции в онлайн-среде для многих площадок как
                        нельзя лучше подходит модель{' '}
                        <a
                            href={`${process.env.NEXT_PUBLIC_INSTANCE_PREFIX}/ru/info/cpa/`}
                            target="_blank"
                            rel="noreferrer"
                            className="underline text-blueGrey-800"
                        >
                            СРА
                        </a>
                        , ведь при ней нет необходимости вкладываться в дорогостоящую и не всегда
                        эффективную рекламу: платить за показы или клики, которые не привели к
                        покупке. В СРА же оплата производится только за приобретенный товар или
                        услугу. При этом вебмастер направляет трафик не на неизвестный пользователю
                        лендинг-однодневку, а на сайт известного и проверенного продавца, что
                        повышает конверсию из просмотра в покупку.
                    </p>
                    <p className="text-blueGray-600 text-p1">
                        Выбирайте партнёрскую программу из арсенала {companyName} и зарабатывайте на
                        покупках вашей аудитории!
                    </p>
                </>
            );
    }
};
